import {authHeader} from '../backend'
import {handleResponse} from './handleResponse'

export const caService = {
  getFallingBallStatistics,
  getPinStatistics
}

function getFallingBallStatistics (ccode, hlidx, sDate, eDate) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/ca/falling-ball/statistics/period?ccode=${ccode}&hlidx=${hlidx}&sDate=${sDate}&eDate=${eDate}&` + Date.now(), requestOptions).then(handleResponse)
}

function getPinStatistics (ccode, hlidx, sDate, eDate) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/ca/pin/statistics/period?ccode=${ccode}&hlidx=${hlidx}&sDate=${sDate}&eDate=${eDate}&` + Date.now(), requestOptions).then(handleResponse)
}



// WEBPACK FOOTER //
// ./src/router/caRouter.js